import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Row } from "@tanstack/react-table";
import { MoreHorizontal, X } from "lucide-react";
import { useState } from "react";
import { ExceptionListEditModal } from "../../list/edit";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<
  TData extends { id: number; final_term?: string | Date | null }
>({ row }: DataTableRowActionsProps<TData>) {
  const [isOpen, setIsOpen] = useState(false);
  const isDisabled = !!row.original.final_term;

  const handleOpenModal = () => {
    if (!isDisabled) setIsOpen(true);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost_none"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
          >
            <MoreHorizontal />
            <span className="sr-only">Abrir Menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[200px]">
          <DropdownMenuItem onClick={handleOpenModal} disabled={isDisabled}>
            Adicionar Fim da Vigência
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="relative bg-white rounded-lg shadow-lg">
            <button
              className="absolute top-2 right-2 p-1 text-gray-700"
              onClick={() => setIsOpen(false)}
            >
              <X className="w-5 h-5" />
            </button>

            <ExceptionListEditModal
              requestData={{ id: row.original.id }}
              onCloseModal={() => setIsOpen(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
